import signedFetch from './util/signedFetch.js';

export default userId => {
  const URL = `${__API_BASE__}/user/${userId}/platform-stats`;

  return signedFetch('getUserPlatformStatistics', URL, 'GET');
};
